import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LocationState {
  value: string;
}

const initialState: LocationState = {
  value: "",
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLocation(state, action: PayloadAction<string>) {
      state.value = action.payload;
    },
    clearLocation(state) {
      state.value = "";
    },
  },
});

export const { setLocation, clearLocation } = locationSlice.actions;
export default locationSlice.reducer;